import { OptionType } from '@evinced-private/ui-common';

import { naturalSort } from 'src/common/helpers/DataFilterHelper';

interface IScanGroupsRawResult {
	scan_groups?: Array<{ scan_id?: string | null; scan_name_any?: string | null } | null> | null;
}

export const transformScanGroups = (rawResults: IScanGroupsRawResult): OptionType[] =>
	(rawResults?.scan_groups ?? [])
		.filter((group): group is { scan_id: string; scan_name_any: string } =>
			Boolean(group?.scan_id && group?.scan_name_any)
		)
		.map((group) => ({ value: group.scan_id, label: group.scan_name_any }))
		.toSorted((a, b) => naturalSort(a.label, b.label));
